<template>
    <div
        v-scroll="onScroll"
        id="sek-popup">
        <div class="logo"
            @click="updateDisplay">
            <img :src="imgSrc">
        </div>
        <div class="content">
            <v-select
                class="mt-3"
                v-model="seguro"
                :items="seguros"
                item-text="name"
                item-value="value"
                @focus="updateWithEmpty('seguro')"
                @blur="updateWithValue('seguro')"
                label="Qual seguro você precisa?"
                placeholder=" ---- "
                return-object />
            <v-text-field 
                label="Informe seu telefone"
                v-model="telefone"
                @focus="updateWithEmpty('telefone')"
                @blur="updateWithValue('telefone')"
                placeholder="(00) 00000-0000" />
            <v-text-field 
                @focus="updateWithEmpty('email')"
                @blur="updateWithValue('email')"
                label="Qual o seu e-mail?"
                v-model="email"
                placeholder="seunome@dominio.com" />
            <v-text-field 
                label="Qual seu Whatsapp?"
                @focus="updateWithEmpty('whatsapp')"
                @blur="updateWithValue('whatsapp')"
                v-model="whatsapp"
                placeholder="(00) 00000-0000" />

            <v-btn
                block
                depressed
                class="white--text mt-5 mb-2"
                color="#ff8800">
                Continuar
            </v-btn>
        </div>
    </div>
</template>

<script>
const defaultValues = {
    seguro: -1,
    telefone: "(00) 00000-0000",
    email: "seunome@dominio.com",
    whatsapp: "(00) 00000-0000",
}

export default {
    data() {
        return {
            imgSrc: require("@/assets/images/logo.png"),
            seguro: -1,
            telefone: "(00) 00000-0000",
            email: "seunome@dominio.com",
            whatsapp: "(00) 00000-0000",
            seguros: [
                { value: -1, name:"----", disabled: true },
                { value: 0, name:"Saúde e Odontológico" },
                { value: 1, name:"Pessoas" },
                { value: 2, name:"Patrimoniais" },
                { value: 3, name:"Riscos financeiros" },
                { value: 4, name:"Automóveis" },
                { value: 5, name:"Transportes" },
                { value: 6, name:"Responsabilidade civil para médico" },
            ]
        }
    },
    methods: {
        updateWithEmpty(value) {
            if (this[value] == defaultValues[value])
                this[value] = ''
        },
        updateWithValue(value) {

            if (!this[value])
                this[value] = defaultValues[value]
        },
        updateDisplay() {
            document.getElementById("sek-popup").classList.toggle('visible')
            document.getElementById("sek-popup").classList.toggle('hide-by-user')
        },
        onScroll() {
            if (document.documentElement.scrollTop > 50 && ! document.getElementById("sek-popup").classList.contains('hide-by-user')) {
                document.getElementById("sek-popup").classList.add('visible')
            }
            else {
                document.getElementById("sek-popup").classList.remove('visible')
            }
        },
    }
}
</script>

<style lang="scss">
#sek-popup {
    height: 0;
    width: 0;
    position: fixed;
    border-radius: 5px;
    bottom: 15px;
    z-index: 9999;
    background: white;
    right: 20px;
    transition: all 0.2s ease;

    &.visible {
        height: 354px;
        width: 290px;
        padding: 20px;

        .logo {
           top: -27px;
           left: 15px;
        }

        .content {
            opacity: 1;
        }
    }

    .content {
        opacity: 0;
        transition: all 0.15s ease;
    }

    .logo {
        transition: all 0.2s ease;
        position: absolute;
        border-radius: 50%;
        background: black;
        border: #007ac0 3px solid;
        height: 50px;
        width: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        top: -50px;
        left: -50px;

        img {
            height: 30px;
            width: 30px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-48%, -53%);
        }
    }

    .v-input {
        margin-bottom: 10px !important;
        
        .v-label {
            color: #007ac0;
            font-weight: bold;
            font-size: 18px;
            top: 0;
        }

        .v-input__control > .v-input__slot:after {
            transform: scaleX(1) !important;
            color: #007ac0;
            height: 1px;
        }

        .v-select__slot, input {
            background: rgba($color: #000000, $alpha: 0.1);
        }

        .v-select__slot input {
            background: none !important;
        }
    }

    .v-text-field__details {
        display: none !important;
    }
}
</style>